import * as yup from "yup";

// Base schema fields shared between create and update
const baseGiftSchema = {
    gift_type: yup
        .object()
        .shape({
            id: yup.string().required("يجب اختيار نوع الهدية"),
            name: yup.string().required("يجب اختيار نوع الهدية"),
        })
        .required("نوع الهدية مطلوب"),
    compensate_type: yup
        .string()
        .oneOf(
            ["days", "traffic", "both"],
            " النوع  يجب أن يكون بيانات أو أيام أو كلاهما"
        )
        .required("النوع   مطلوب"),
    valid_from: yup.date().required("تاريخ البداية مطلوب"),
    valid_to: yup
        .date()
        .min(
            yup.ref("valid_from"),
            "تاريخ النهاية يجب أن يكون بعد تاريخ البداية"
        )
        .required("تاريخ النهاية مطلوب"),
    days_amount: yup
        .number()
        .nullable()
        .when("compensate_type", {
            is: (compensate_type) =>
                compensate_type === "days" || compensate_type === "both",
            then: (schema) =>
                schema
                    .required("عدد الأيام مطلوب")
                    .positive("عدد الأيام يجب أن يكون رقم موجب"),
            otherwise: (schema) =>
                schema
                    .notRequired()
                    .transform((value) => (value === 0 ? null : value)),
        }),
    traffic_amount: yup
        .number()
        .nullable()
        .when("compensate_type", {
            is: (compensate_type) =>
                compensate_type === "traffic" || compensate_type === "both",
            then: (schema) =>
                schema
                    .required("كمية البيانات مطلوبة")
                    .positive("كمية البيانات يجب أن تكون رقم موجب"),
            otherwise: (schema) =>
                schema
                    .notRequired()
                    .transform((value) => (value === 0 ? null : value)),
        }),
    comment: yup.string(),
};

// Create schema - usernames required
export const giftSchema = yup.object().shape({
    ...baseGiftSchema,
    usernames: yup
        .array()
        .of(yup.string())
        .min(1, "يجب إضافة اسم مستخدم واحد على الأقل")
        .required("أسماء المستخدمين مطلوبة"),
});

// Update schema - usernames optional (can be empty array or null)
export const updateGiftSchema = yup.object().shape({
    ...baseGiftSchema,
    usernames: yup
        .array()
        .of(yup.string())
        .nullable()
        .notRequired(),
});
